var map = {
	"./1/symbol_0.png": "8962",
	"./1/symbol_1.png": "d7f9",
	"./1/symbol_10.png": "f7f1",
	"./1/symbol_11.png": "8c1d",
	"./1/symbol_12.png": "1d03",
	"./1/symbol_13.png": "08dd",
	"./1/symbol_2.png": "8fc5",
	"./1/symbol_3.png": "b951",
	"./1/symbol_4.png": "7b2c",
	"./1/symbol_5.png": "1f62",
	"./1/symbol_6.png": "74c2",
	"./1/symbol_7.png": "5b32",
	"./1/symbol_8.png": "a861",
	"./1/symbol_9.png": "127b",
	"./line/line1.png": "a114",
	"./line/line2.png": "5cdc",
	"./line/line3.png": "2335",
	"./line/line4.png": "c1ec",
	"./line/line5.png": "3acf",
	"./multiplier/x10.png": "9106",
	"./multiplier/x100.png": "dbfe",
	"./multiplier/x2.png": "ff95",
	"./multiplier/x20.png": "ccfc",
	"./multiplier/x25.png": "f82e",
	"./multiplier/x3.png": "2f8e",
	"./multiplier/x4.png": "4b79",
	"./multiplier/x5.png": "744a",
	"./multiplier/x50.png": "4099",
	"./multiplier/x6.png": "0e23",
	"./multiplier/x7.png": "e6fa",
	"./multiplier/x8.png": "b75b",
	"./multiplier/x9.png": "6c4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e697";